import { CalendarDays, ClipboardCheck, FileText } from "lucide-react";
import { useState } from "react";
import { Link, useLocation } from "react-router";
import { MobileBottomNav } from "../design/components/MobileBottomNav.js";
import { ResponsiveSheet } from "../design/components/ResponsiveSheet.js";
import { HelpFeedbackContent } from "./HelpFeedback.js";

export function ParticipantMobileNav({ section }: { section: string }) {
  const [open, setOpen] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);
  const location = useLocation();
  const close = () => { setOpen(false); setHelpOpen(false); };
  return <>
    <MobileBottomNav activeKey={section} onMore={() => { setHelpOpen(false); setOpen(true); }} items={[
      { key: "conferences", label: "Conferences", href: "/my/conferences", icon: <CalendarDays size={20} /> },
      { key: "submissions", label: "Submissions", href: "/my/submissions", icon: <FileText size={20} /> },
      { key: "reviews", label: "Reviews", href: "/my/reviews", icon: <ClipboardCheck size={20} /> },
    ]} />
    <ResponsiveSheet open={open} title={helpOpen ? "Help & feedback" : "More work options"} onClose={close}>
      {helpOpen ? <HelpFeedbackContent pathname={location.pathname} onBack={() => setHelpOpen(false)} /> : <nav className="app-mobile-more" aria-label="More work options">
        <button type="button" onClick={() => setHelpOpen(true)}>Help &amp; feedback</button>
        <Link to="/my/registrations" onClick={close}>All registrations</Link>
        <Link className="participant-organize-mobile" to="/app" onClick={close}>Organize</Link>
        <Link to="/" onClick={close}>Return to landing page</Link>
      </nav>}
    </ResponsiveSheet>
  </>;
}
